module.exports = __webpack_public_path__ + "img/schale_1_a.1e4ba3a4.jpg";